import { Component } from "react";
import Select from "react-select";
import $ from "jquery";
import update from "immutability-helper";
import { validated } from "react-custom-validation";
import { adminlimit } from "../../Settings/Config";
import api from "../../../utils/axios";
import {
  showContaimerLoader,
  encodeValue,
  removeItem,
  showPageCount,
  removeChar,
  isEmpty,
  showLoader,
  hideLoader,
  showAlert,
  isSingleSelect,
  onlyPhoneNumber,
  isEmail,
  hasPermission,
} from "../../Settings/Settings";
import Pagenation from "../../Layout/Pagenation";
const module = "candidatendk";
const modulePath = "/candidate";
const moduleName = "NKD";
const relation_ = ["FATHER", "MOTHER", "SON", "DAUGHTER", "BROTHER", "SISTER", "HUSBAND", "WIFE", "MOTHER-IN-LAW", "FATHER-IN-LAW", "UNCLE", "AUNT", "NEPHEW", "NIECE"];
const idName = "ndf";
const moduleID = 25;
class List extends Component {
  constructor(props) {
    super(props);
    this.state = {
      pageLimit: { label: adminlimit, value: adminlimit },
      loading: true,
      totalRecords: 0,
      totalPage: 0,
      currentPage: 1,
      listdata: [],
      name: "",
      portAgentList: [],
      editID: "",
      postdata: {
        kin_name: "",
        kin_relation: "",
        kin_contact_number: "",
        kin_email: "",
        kin_contact_address: "",
        kin_priority: "",
      },
      detaildata: [],
      restForm: false,
    };
    this.handleChangeText = this.handleChangeText.bind(this);
  }

  componentDidMount() {
    this.loadList(1);
    this.loadDropdown();
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.state.formpost !== nextProps.formpost && this.props.formpost !== nextProps.formpost) {
      if (nextProps.formpost.length > 0) {
        hideLoader(`submit_${idName}_frm`);
        const errMsg = nextProps.formpost[0].message;
        if (nextProps.formpost[0].status === "ok") {
          showAlert("Success", errMsg, "success", "No");
          this.props.history.push(modulePath);
        } else {
          showAlert("Error", errMsg, "error", "No");
        }
      }
    }
  }
  searchList(e) {
    e.preventDefault();
    this.setState({ loading: true, currentPage: 1 }, () => {
      this.loadList(1);
    });
  }
  resetSearch(e) {
    e.preventDefault();
    this.setState(
      {
        loading: true,
        name: "",
        currentPage: 1,
      },
      () => {
        this.loadList(1);
      },
    );
  }
  loadList(offset) {
    this.setState({ loading: true });
    let addParams = "";
    if (this.state.name !== "") {
      addParams += "&name=" + this.state.name;
    }

    try {
      api
        .get(`${module}?limit=${this.state.pageLimit.value}&offset=${offset}&candidateId=${this.props.candidateID}${addParams}`)
        .then((res) => {
          if (res.data.status === "ok") {
            this.setState({ listdata: res.data.result, loading: false, totalRecords: res.data.totalRecords, totalPage: res.data.totalPages });
          }
        })
        .catch((err) => {
          console.error(err);
          this.setState({ loading: false, totalRecords: 0, totalPage: 0, currentPage: 1, listdata: [] });
        });
    } catch (e) {
      this.setState({ loading: false, totalRecords: 0, totalPage: 0, currentPage: 1, listdata: [] });
    }
  }
  loadDropdown() {
    api
      .get("portagent/dropdownname")
      .then((res) => {
        if (res.data.status === "ok") {
          this.setState({ portAgentList: res.data.result });
        }
      })
      .catch((err) => {
        console.error(err);
      });
  }
  edit(editID, e) {
    e.preventDefault();
    this.setState({ editID: editID }, () => {
      api
        .get(`${module}/detail/${encodeValue(editID)}`)
        .then((res) => {
          if (res.data.status === "ok") {
            $(`#addNew${idName}`).trigger("click");
            const result = res.data.result;
            this.setState({
              postdata: {
                kin_name: result.kin_name,
                kin_relation: result.kin_relation !== "" && result.kin_relation !== null ? { label: result.kin_relation, value: result.kin_relation } : "",
                kin_contact_number: result.kin_contact_number || "",
                kin_email: result.kin_email || "",
                kin_contact_address: result.kin_contact_address,
                kin_priority: result.kin_priority,
              },
            });
          }
        })
        .catch((err) => {
          console.error(err);
        });
    });
  }
  sateValChange = (field, value) => {
    if (field === "page") {
      this.setState(
        {
          loading: true,
          currentPage: value,
        },
        () => {
          this.loadList(value);
        },
      );
    } else if (field === "pageLimit") {
      this.setState({ pageLimit: value, currentPage: 1 }, () => {
        this.loadList(1);
      });
    } else if (field === "restForm") {
      this.setState({ restForm: value });
    }
  };
  handleChangeText(event) {
    const name = event.target.name;
    const value = event.target.value;
    this.setState({ [name]: value });
  }
  handleSelectChange(name, value) {
    this.setState({ [name]: value });
  }
  removeItem(deleteID, e) {
    e.preventDefault();
    removeItem(deleteID, module, this.sateValChange, this.state.currentPage);
  }

  fieldChange = (field, value) => {
    if (field === "kin_contact_number") {
      value = onlyPhoneNumber(value);
    }
    this.setState(update(this.state, { postdata: { [field]: { $set: removeChar(value) } } }));
  };

  handleSubmit = () => {
    showLoader(`submit_${idName}_frm`);
    const postData = this.state.postdata;

    const postObject = {
      candidateId: this.props.candidateID,
      kin_name: postData.kin_name,
      kin_relation: postData.kin_relation?.value || "",
      kin_email: postData.kin_email,
      kin_contact_number: postData.kin_contact_number,
      kin_contact_address: postData.kin_contact_address,
      kin_priority: postData.kin_priority,
    };

    let post_url = `${module}`;
    let method = "post";
    if (this.state.editID !== "") {
      post_url = `${module}/${encodeValue(this.state.editID)}`;
      method = "put";
    }
    api[method](post_url, postObject)
      .then((res) => {
        hideLoader(`submit_${idName}_frm`);
        $(".btn-close").trigger("click");
        const errMsg = res.data.message;
        if (res.data.status === "ok") {
          showAlert("Success", errMsg, "success", "No");
          this.loadList(1);
          this.resetFrom();
        }
      })
      .catch((err) => {
        hideLoader(`submit_${idName}_frm`);
        const errMsg = err.response.data?.message || err?.message;
        showAlert("Error", errMsg, "error", "No");
        console.error(err);
      });
  };
  closePopup() {
    this.resetFrom();
  }
  resetFrom() {
    this.setState({
      editID: "",
      restForm: true,
      postdata: {
        kin_name: "",
        kin_relation: "",
        kin_contact_number: "",
        kin_email: "",
        kin_contact_address: "",
        kin_priority: "",
      },
    });
  }

  render() {
    return (
      <div className="main-container container-fluid mx-3">
        <div className="page-header">
          <h1 className="page-title">{moduleName} Details</h1>
          <div>
            {hasPermission(moduleID, "add") && (
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <button
                    className="btn btn-sm btn-success badge mx-4"
                    type="button"
                    data-bs-toggle="modal"
                    data-bs-target={`#${idName}modal`}
                    data-backdrop="static"
                    data-keyboard="false"
                    id={`addNew${idName}`}
                  >
                    <i className="fa fa-plus"></i> Add New
                  </button>
                </li>
              </ol>
            )}
          </div>
        </div>
        <div className="row">
          <div className="col-md-12 col-xl-12">
            <div className="card">
              <div className="card-body">
                <div className="form-row">
                  <div className="col-md-3">
                    <input type="text" className="form-control" placeholder={"Search keyword"} name="name" onChange={this.handleChangeText} value={this.state.name} />
                  </div>
                  <div className="col-md-3">
                    <a href="/" className="btn btn-primary" onClick={this.searchList.bind(this)}>
                      Search
                    </a>
                    <a href="/" className="btn btn-secondary offset-1" onClick={this.resetSearch.bind(this)}>
                      Reload
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-xl-12">
            <div className="card">
              {this.state.loading ? (
                showContaimerLoader()
              ) : (
                <div>
                  <div className="card-header">
                    {parseInt(this.state.totalPage) > 0 && showPageCount(moduleName, this.state.currentPage, this.state.totalPage, this.state.totalRecords, this.sateValChange, this.state.pageLimit)}
                  </div>
                  <div className="card-body">
                    <div className="table-responsive">
                      <table className="table border text-nowrap text-md-nowrap table-bordered mb-0">
                        <thead className="table-primary">
                          <tr>
                            {(hasPermission(moduleID, "edit") || hasPermission(moduleID, "delete")) && <th className="text-center">Actions </th>}
                            <th>S.No.</th>
                            <th>Name</th>
                            <th>Relation</th>
                            <th>Contact Number</th>
                            <th>Email</th>
                            <th>Address</th>
                            <th>Percentage of Share</th>
                          </tr>
                        </thead>
                        <tbody>
                          {this.state.listdata.length > 0 ? (
                            this.state.listdata.map((item, index) => {
                              return (
                                <tr key={index}>
                                  {(hasPermission(moduleID, "edit") || hasPermission(moduleID, "delete")) && (
                                    <td className="text-center text-nowrap" valign="top">
                                      {hasPermission(moduleID, "edit") && (
                                        <a href="/" onClick={this.edit.bind(this, item.id)} className="me-2">
                                          <i className="fa fa-pencil-square-o"></i>
                                        </a>
                                      )}
                                      {hasPermission(moduleID, "delete") && (
                                        <a href="/" className="delete_record" onClick={this.removeItem.bind(this, encodeValue(item.id))}>
                                          <i className="fa fa-trash"></i>
                                        </a>
                                      )}
                                    </td>
                                  )}
                                  <td>{(parseInt(this.state.currentPage) - 1) * parseInt(this.state.pageLimit.value) + (parseInt(index) + 1)}</td>
                                  <td>{item.kin_name}</td>
                                  <td>{item.kin_relation}</td>
                                  <td>{item.kin_contact_number}</td>
                                  <td>{item.kin_email}</td>
                                  <td>{item.kin_contact_address}</td>
                                  <td>{item.kin_priority} %</td>
                                </tr>
                              );
                            })
                          ) : (
                            <tr>
                              <td className="text-center" colSpan={8}>
                                No {moduleName} Found
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                    {parseInt(this.state.totalPage) > 1 && (
                      <Pagenation
                        params={{
                          totalRecords: this.state.totalRecords,
                          totalPage: this.state.totalPage,
                          currentPage: this.state.currentPage,
                        }}
                        sateValChange={this.sateValChange}
                      />
                    )}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>

        <div className="modal fade" id={`${idName}modal`} tabIndex="-1" role="dialog" data-bs-backdrop="static" data-bs-keyboard="false">
          <div className="modal-dialog modal-xl" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">{`${this.state.editID !== "" ? "Update" : "Add New"} ${moduleName}`}</h5>
                <button className="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={this.closePopup.bind(this)}>
                  <span aria-hidden="true">×</span>
                </button>
              </div>
              <PostForm
                {...this.props}
                fields={this.state.postdata}
                portAgentList={this.state.portAgentList}
                restForm={this.state.restForm}
                sateValChange={this.sateValChange}
                onChange={this.fieldChange}
                onValid={this.handleSubmit}
                closePopup={this.closePopup.bind(this)}
                editID={this.state.editID}
                error_msg={this.state.error_msg}
                onInvalid={() => {
                  console.log("Form invalid!");
                }}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default List;

function validationConfig(props) {
  const { kin_name, kin_relation, kin_email, kin_priority } = props.fields;

  return {
    fields: ["kin_name", "kin_relation", "kin_email", "kin_priority"],
    validations: {
      kin_name: [[isEmpty, kin_name]],
      kin_relation: [[isSingleSelect, kin_relation]],
      kin_email: [[isEmail, kin_email]],
      kin_priority: [[isEmpty, kin_priority]],
    },
  };
}
class PostForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      restData: false,
    };
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.restForm === true) {
      this.props.sateValChange("restForm", false);
      setTimeout(() => {
        this.handleReset();
      }, 1000);
    }
  }
  handleSelectChange(name, value) {
    this.props.onChange(name, value);
  }
  handleChangeFile(name, value) {
    this.props.onChange(name, value);
  }
  handleFileChange = (e) => {
    const file = e.target.files[0];
    const name = e.target.name;
    if (file) {
      const previewUrl = URL.createObjectURL(file);
      this.props.onChange(name, previewUrl);
    }
  };
  closePopup() {
    this.props.sateValChange("restForm", true);
  }
  handleReset = () => {
    const { $validation } = this.props;
    // 2️⃣ Reset all validation errors
    Object.keys($validation).forEach((key) => {
      if ($validation[key]) {
        $validation[key].show = false;
        $validation[key].error = {};
      }
    });
    this.setState({ restData: this.state.restData });
  };

  render() {
    const { fields, onChange, onValid, onInvalid, $field, $validation } = this.props;
    let errMsgkin_name,
      errMsgkin_relation,
      errMsgkin_email,
      errMsgkin_priority = "";
    if ($validation.kin_name.error.reason !== undefined) {
      errMsgkin_name = $validation.kin_name.show && <span className="error">{$validation.kin_name.error.reason}</span>;
    }
    if ($validation.kin_relation.error.reason !== undefined) {
      errMsgkin_relation = $validation.kin_relation.show && <span className="error">{$validation.kin_relation.error.reason}</span>;
    }
    if ($validation.kin_email.error.reason !== undefined) {
      errMsgkin_email = $validation.kin_email.show && <span className="error">{$validation.kin_email.error.reason}</span>;
    }
    if ($validation.kin_priority.error.reason !== undefined) {
      errMsgkin_priority = $validation.kin_priority.show && <span className="error">{$validation.kin_priority.error.reason}</span>;
    }

    return (
      <>
        <div>
          <div className="modal-body">
            <div className="form-group">
              <div className="form-row">
                <div className="form-group col-md-3">
                  <label className="form-label">
                    Name<span className="lbl-error">*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control upper-case"
                    placeholder="Name"
                    name="kin_name"
                    value={fields.kin_name}
                    {...$field("kin_name", (e) => onChange("kin_name", e.target.value))}
                  />
                  {errMsgkin_name}
                </div>
                <div className="form-group col-md-3">
                  <label className="form-label">
                    Relation<span className="lbl-error">*</span>
                  </label>
                  <Select
                    value={fields.kin_relation}
                    onChange={this.handleSelectChange.bind(this, "kin_relation")}
                    placeholder="Select Relation"
                    options={relation_.map((item) => {
                      return {
                        label: item,
                        value: item,
                      };
                    })}
                  />
                  {errMsgkin_relation}
                </div>

                <div className="form-group col-md-3">
                  <label className="form-label">Contact Number</label>
                  <input
                    type="text"
                    className="form-control upper-case"
                    placeholder="Contact Number"
                    name="kin_contact_number"
                    value={fields.kin_contact_number}
                    {...$field("kin_contact_number", (e) => onChange("kin_contact_number", e.target.value))}
                  />
                </div>
                <div className="form-group col-md-3">
                  <label className="form-label">Email</label>
                  <input
                    type="text"
                    className="form-control upper-case"
                    placeholder="Email"
                    name="kin_email"
                    value={fields.kin_email}
                    {...$field("kin_email", (e) => onChange("kin_email", e.target.value))}
                  />
                  {errMsgkin_email}
                </div>
                <div className="form-group col-md-3">
                  <label className="form-label">Address</label>
                  <input
                    type="text"
                    className="form-control upper-case"
                    placeholder="Address"
                    name="kin_contact_address"
                    value={fields.kin_contact_address}
                    {...$field("kin_contact_address", (e) => onChange("kin_contact_address", e.target.value))}
                  />
                </div>
                <div className="form-group col-md-3">
                  <label className="form-label">
                    Percentage of Share<span className="lbl-error">*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control upper-case"
                    placeholder="Percentage of Share"
                    name="kin_priority"
                    value={fields.kin_priority}
                    {...$field("kin_priority", (e) => onChange("kin_priority", e.target.value))}
                  />
                  {errMsgkin_priority}
                </div>
              </div>
            </div>
          </div>
          <div className="modal-footer">
            <button className="btn btn-secondary" data-bs-dismiss="modal" onClick={this.closePopup.bind(this)}>
              Close
            </button>
            <button
              className="btn btn-primary"
              id={`submit_${idName}_frm`}
              onClick={(e) => {
                e.preventDefault();
                this.props.$submit(onValid, onInvalid);
              }}
            >
              Save changes
            </button>
          </div>
        </div>
      </>
    );
  }
}
PostForm = validated(validationConfig)(PostForm);
